import * as tslib_1 from "tslib";
import * as i0 from "@angular/core";
import * as i1 from "../hash.service";
var GpuFingerprintService = /** @class */ (function () {
    function GpuFingerprintService(hashService) {
        this.hashService = hashService;
    }
    GpuFingerprintService.prototype.identity = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        var canvas = document.createElement('canvas');
                        canvas.width = 4;
                        canvas.height = 4;
                        canvas.style.position = 'fixed';
                        canvas.style.top = '-999px';
                        canvas.style.opacity = '0.01';
                        document.body.appendChild(canvas);
                        var gl = (canvas.getContext('webgl2') ||
                            canvas.getContext('webgl') ||
                            canvas.getContext('experimental-webgl'));
                        if (!gl) {
                            canvas.remove();
                            return resolve({ status: 'webgl_not_supported', gpu_id: '' });
                        }
                        var vsSource = "\n        attribute vec2 position;\n        void main() { gl_Position = vec4(position, 0.0, 1.0); }\n    ";
                        var fsSource = "\n        precision highp float;\n        void main() {\n            vec2 coord = gl_FragCoord.xy / 4.0;\n            float r = fract(sin(coord.x * 12.9898) * 43758.5453);\n            float g = fract(cos(coord.y * 78.233) * 23421.6312);\n            gl_FragColor = vec4(r, g, fract(r + g), 1.0);\n        }\n    ";
                        function createShader(glContext, type, source) {
                            var shader = glContext.createShader(type);
                            if (!shader)
                                return null;
                            glContext.shaderSource(shader, source);
                            glContext.compileShader(shader);
                            return glContext.getShaderParameter(shader, glContext.COMPILE_STATUS) ? shader : null;
                        }
                        var vs = createShader(gl, gl.VERTEX_SHADER, vsSource);
                        var fs = createShader(gl, gl.FRAGMENT_SHADER, fsSource);
                        if (!vs || !fs) {
                            canvas.remove();
                            return resolve({ status: 'shader_failed', gpu_id: '' });
                        }
                        var program = gl.createProgram();
                        if (!program) {
                            canvas.remove();
                            return resolve({ status: 'program_failed', gpu_id: '' });
                        }
                        gl.attachShader(program, vs);
                        gl.attachShader(program, fs);
                        gl.linkProgram(program);
                        gl.useProgram(program);
                        var vertices = new Float32Array([-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1]);
                        var buffer = gl.createBuffer();
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        gl.bufferData(gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW);
                        var positionLocation = gl.getAttribLocation(program, 'position');
                        gl.enableVertexAttribArray(positionLocation);
                        gl.vertexAttribPointer(positionLocation, 2, gl.FLOAT, false, 0, 0);
                        gl.clearColor(0, 0, 0, 0);
                        gl.clear(gl.COLOR_BUFFER_BIT);
                        gl.drawArrays(gl.TRIANGLES, 0, 6);
                        requestAnimationFrame(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var pixels, pixelsString;
                            return tslib_1.__generator(this, function (_a) {
                                try {
                                    pixels = new Uint8Array(4 * 4 * 4);
                                    gl.readPixels(0, 0, 4, 4, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
                                    gl.deleteBuffer(buffer);
                                    gl.deleteProgram(program);
                                    gl.deleteShader(vs);
                                    gl.deleteShader(fs);
                                    canvas.remove();
                                    pixelsString = pixels.join(',');
                                    resolve({
                                        status: 'success',
                                        gpu_id: this.hashService.sha256(pixelsString)
                                    });
                                }
                                catch (e) {
                                    canvas.remove();
                                    resolve({ status: 'compromised', gpu_id: 'blocked_bypass' });
                                }
                                return [2 /*return*/];
                            });
                        }); });
                    })];
            });
        });
    };
    GpuFingerprintService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GpuFingerprintService_Factory() { return new GpuFingerprintService(i0.ɵɵinject(i1.HashService)); }, token: GpuFingerprintService, providedIn: "root" });
    return GpuFingerprintService;
}());
export { GpuFingerprintService };
